import { t } from 'i18n';
import React from 'react';
import { ModalHeader, ModalBody, Modal } from '@teko/ui';
import { CommonRegionPickerProps } from 'types';
import { DropDownRegionPicker } from 'components/mobile/organisms/DropDownRegionPicker';
import { RegionPicker } from '@teko/teko-ecommerce';
import { CloseOutlined } from '@teko/ds-icon';
import { styled, Button } from '@teko/ds-desktop';
type PopupRegionPickerProps = CommonRegionPickerProps;
export const PopupRegionPicker: React.FC<PopupRegionPickerProps> = ({
  showPopup,
  selected,
  setSelected,
  terminals,
  locationOptions,
  onClosePopup,
  onSubmitNewLocation,
  activeLocation,
  title,
  useDropdownPicker,
}: PopupRegionPickerProps) => {
  return (
    <>
      {terminals?.length > 1 && (
        <Modal size="sm" show={showPopup} onHide={() => onClosePopup()}>
          <ModalHeader>{t('Chọn khu vực giao hàng')}</ModalHeader>
          {!!activeLocation && (
            <CloseIcon onClick={() => onClosePopup()}>
              <CloseOutlined size={32} color="#000000" />
            </CloseIcon>
          )}
          <ModalBody>
            {useDropdownPicker ? (
              <Wrapper>
                <span style={{ textAlign: 'justify' }}>{title}</span>
                <ImgWrapper
                  src={'/umbala/location.svg'}
                  alt="choose location"
                />
                <DropDownRegionPicker
                  terminals={terminals}
                  onSelectTerminal={setSelected}
                />
                <StyledButton
                  variant="primary"
                  size="m"
                  block
                  onClick={() => onSubmitNewLocation()}
                >
                  {t('Xác nhận')}
                </StyledButton>
              </Wrapper>
            ) : (
              <StyledPicker
                options={locationOptions}
                value={selected}
                onChange={setSelected}
                onSubmit={() => {
                  onSubmitNewLocation();
                }}
                title={title}
              />
            )}
          </ModalBody>
        </Modal>
      )}
    </>
  );
};
const StyledPicker = styled(RegionPicker)`
  margin-bottom: 24px;
`;
const Wrapper = styled.div`
  text-align: center;
  margin-bottom: 24px;
`;
const ImgWrapper = styled.img`
  margin: 32px;
`;
const StyledButton = styled(Button)`
  margin-top: 12px;
`;
const CloseIcon = styled.div`
  z-index: 1060;
  position: absolute;
  top: 12px;
  right: 12px;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
